import { client } from '@/lib/sanity'

type UserPreferenceDoc = {
  _id: string
  userId: string
  selectedBrandId?: string
}

const getUserPreferenceDocId = (userId: string) => `userPreference.${userId}`

export async function getUserSelectedBrandId(userId: string): Promise<string | null> {
  if (!userId) return null
  const pref = await client.fetch<UserPreferenceDoc | null>(
    `*[_type == "userPreference" && userId == $userId][0]{
      _id,
      userId,
      selectedBrandId
    }`,
    { userId },
  )
  return pref?.selectedBrandId || null
}

export async function setUserSelectedBrandId(userId: string, brandId: string): Promise<void> {
  if (!userId || !brandId) return
  const docId = getUserPreferenceDocId(userId)
  await client.createOrReplace({
    _id: docId,
    _type: 'userPreference',
    userId,
    selectedBrandId: brandId,
  })
}
